import { Box, Grid } from "@mui/material";
import { useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import { formLabel } from "../utils/formFieldLabels";
import "./AdmissionForm.css";
import CommonAccordion from "./CommonAccordion";
import ErrorMessage from "./ErrorMessage";
import FormFieldLabel from "./FormFieldLabel";
import Input from "./Input";
import "./phoneInput.css";
import { maxLength } from "../utils/methods";

const AdmissionForm6 = ({
    formData,
    handleChange,
    errors,
    errorTitle,
    showError
}) => {

    useEffect(() => {
        document.title = "AUMS • Academic";
        if (localStorage.getItem("FormData")) {
        }
    });


    return (
        <Box sx={{ gap: "10rem" }}>

            <Box>

                <CommonAccordion
                    defaultExpanded={true}
                    englishLabel={formLabel.headings.emergencyPageTitle.english}
                    arabicLabel={formLabel.headings.emergencyPageTitle.arabic}
                >
                    <Grid
                        container
                        spacing={1}
                        className="border-[1px] p-3 rounded-md"
                        style={{ marginTop: ".1rem" }}
                    >
                        {/* <p className="flex gap-1 items-center my-3 font-bold uppercase ml-2">
              <IoPersonCircle className="text-2xl text-[#B70042] " />
              Person 1
            </p> */}
                        <Grid item container spacing={4}>
                            <Grid xs={12} md={6} item>
                                <Input
                                    englishLabel={formLabel.emergency.name.english}
                                    arabicLabel={formLabel.emergency.name.arabic}
                                    value={formData.emergency[0].name.value}
                                    handleChange={(e) =>
                                        handleChange(e, "emergency", "0", "name")
                                    }
                                />
                                {errors?.emergencies?.[0]?.emergencyName && (
                                    <ErrorMessage
                                        errorMessage={errors?.emergencies?.[0]?.emergencyName}
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} md={6} item>
                                <Input
                                    englishLabel={formLabel.emergency.relationship.english}
                                    arabicLabel={formLabel.emergency.relationship.arabic}
                                    value={formData.emergency[0].relationship.value}
                                    handleChange={(e) =>
                                        handleChange(e, "emergency", "0", "relationship")
                                    }
                                />
                                {errors?.emergencies?.[0]?.emergencyRelationship && (
                                    <ErrorMessage
                                        errorMessage={
                                            errors?.emergencies?.[0]?.emergencyRelationship
                                        }
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} md={6} item>
                                <Input
                                    type={"number"}
                                    englishLabel={formLabel.emergency.civilId.english}
                                    arabicLabel={formLabel.emergency.civilId.arabic}
                                    value={formData.emergency[0].civilId.value}
                                    max={12}
                                    handleChange={function (e) {
                                        if (maxLength(e, 12)) return;

                                        return handleChange(e, "emergency", "0", "civilId");
                                    }
                                    }
                                />
                                {errors?.emergencies?.[0]?.emergencyCivilId && (
                                    <ErrorMessage
                                        errorMessage={errors?.emergencies?.[0]?.emergencyCivilId}
                                    />
                                )}
                            </Grid>
                            <Grid xs={12} md={6} item>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        flexDirection: "column",
                                        gap: "0.3rem"
                                    }}
                                >
                                    <FormFieldLabel
                                        englishLabel={formLabel.emergency.contact.english}
                                        arabicLabel={formLabel.emergency.contact.arabic}
                                    />

                                    <PhoneInput
                                        inputStyle={{
                                            width: "100%",
                                            border: "1px solid lightgray",
                                            borderRadius: "8px",
                                            background: "#F6F2F8",
                                            height: "2.6rem"
                                            /* Add any additional styles you need */
                                        }}
                                        country={"kw"}
                                        value={formData.emergency[0].contact.value}
                                        // onlyCountries={['in', 'de', 'ru']}
                                        onChange={(value, countryData) => {
                                            const countryCodeNumber = countryData?.dialCode;
                                            handleChange(
                                                { target: { value } },
                                                "emergency",
                                                "0",
                                                "contact"
                                            );
                                            handleChange(
                                                { target: { value: countryCodeNumber } },
                                                "emergency",
                                                "0",
                                                "contact",
                                                "phoneCode"
                                            );
                                        }}
                                    />
                                    {errors?.emergencies?.[0]?.emergencyContact && (
                                        <ErrorMessage
                                            errorMessage={errors?.emergencies?.[0]?.emergencyContact}
                                        />
                                    )}
                                </div>
                                {/* <Input endornment={<EmailOutlinedIcon/>} label={item.label} /> */}
                                {/* <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
                                                       <label className='label'>{item.label}</label>
                                                       <input style={{ backgroundColor: "lightgray", border: "none", borderRadius: '8px', height: "2rem" }} />
                                                   </div> */}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={1}
                        className="border-[1px] p-3 rounded-md"
                        style={{ marginTop: "1rem" }}
                    >
                        {/* <p className="flex gap-1 items-center my-3 font-bold uppercase ml-2">
              <IoPersonCircle className="text-2xl text-[#B70042] " />
              Person 2 <i className="lowercase">(optional)</i>
            </p> */}
                        {/* <label className="autoSaverSwitch relative inline-flex cursor-pointer select-none items-center ml-2">
              <input
                type="checkbox"
                name="autoSaver"
                className="sr-only "
                checked={formData.emergency[1].personTwo.value}
                onChange={(e) => {
                  handleChange(
                    { target: { value: e.target.checked } },
                    "emergency",
                    "1",
                    "personTwo"
                  );
                }}
              />
              <span
                className={`slider mr-3 flex h-[22px] w-[40px] items-center rounded-full p-1 duration-200 ${"bg-[#B70042]"
                  }`}
              >
                <span
                  className={`dot h-[16px] w-[16px] rounded-full bg-white duration-200 ${"translate-x-4"
                    }`}
                ></span>
              </span>
              <span className="label flex items-center text-sm font-medium text-black"></span>
            </label> */}
                        {(
                            <Grid item container spacing={4}>
                                <Grid xs={12} md={6} item>
                                    <Input
                                        englishLabel={formLabel.emergency.name.english}
                                        arabicLabel={formLabel.emergency.name.arabic}
                                        value={formData.emergency[1].name.value}
                                        handleChange={(e) =>
                                            handleChange(e, "emergency", "1", "name")
                                        }
                                    />
                                    {errors?.emergencies?.[1]?.emergencyName && (
                                        <ErrorMessage
                                            errorMessage={errors?.emergencies?.[1]?.emergencyName}
                                        />
                                    )}
                                </Grid>

                                <Grid xs={12} md={6} item>
                                    <Input
                                        englishLabel={formLabel.emergency.relationship.english}
                                        arabicLabel={formLabel.emergency.relationship.arabic}
                                        value={formData.emergency[1].relationship.value}
                                        handleChange={(e) =>
                                            handleChange(e, "emergency", "1", "relationship")
                                        }
                                    />
                                    {errors?.emergencies?.[1]?.emergencyRelationship && (
                                        <ErrorMessage
                                            errorMessage={
                                                errors?.emergencies?.[1]?.emergencyRelationship
                                            }
                                        />
                                    )}
                                </Grid>

                                <Grid xs={12} md={6} item>
                                    <Input
                                        englishLabel={formLabel.emergency.civilId.english}
                                        arabicLabel={formLabel.emergency.civilId.arabic}
                                        type={"number"}
                                        value={formData.emergency[1].civilId.value}
                                        max={12}

                                        handleChange={function (e) {
                                            if (maxLength(e, 12)) return;

                                            return handleChange(e, "emergency", "1", "civilId");
                                        }
                                        }
                                    />
                                    {errors?.emergencies?.[1]?.emergencyCivilId && (
                                        <ErrorMessage
                                            errorMessage={errors?.emergencies?.[1]?.emergencyCivilId}
                                        />
                                    )}
                                </Grid>

                                <Grid xs={12} md={6} item>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            flexDirection: "column",
                                            gap: "0.3rem"
                                        }}
                                    >
                                        <FormFieldLabel
                                            englishLabel={formLabel.emergency.contact.english}
                                            arabicLabel={formLabel.emergency.contact.arabic}
                                        />

                                        <PhoneInput
                                            inputStyle={{
                                                width: "100%",
                                                border: "1px solid lightgray",
                                                borderRadius: "8px",
                                                background: "#F6F2F8",
                                                height: "2.6rem"
                                            }}
                                            country={"kw"}
                                            value={formData.emergency[1].contact.value}
                                            // onlyCountries={['in', 'de', 'ru']}
                                            onChange={(value, countryData) => {
                                                const countryCodeNumber = countryData?.dialCode;
                                                handleChange(
                                                    { target: { value } },
                                                    "emergency",
                                                    "1",
                                                    "contact"
                                                );
                                                handleChange(
                                                    { target: { value: countryCodeNumber } },
                                                    "emergency",
                                                    "1",
                                                    "contact",
                                                    "phoneCode"
                                                );
                                            }}
                                        />
                                        {errors?.emergencies?.[1]?.emergencyContact && (
                                            <ErrorMessage
                                                errorMessage={
                                                    errors?.emergencies?.[1]?.emergencyContact
                                                }
                                            />
                                        )}
                                    </div>
                                    {/* <Input endornment={<EmailOutlinedIcon/>} label={item.label} /> */}
                                    {/* <div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
                                                       <label className='label'>{item.label}</label>
                                                       <input style={{ backgroundColor: "lightgray", border: "none", borderRadius: '8px', height: "2rem" }} />
                                                   </div> */}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </CommonAccordion>

                {/* <Box className="px-4">
          <AdmissionForm5
            errors={errors}
            formData={formData}
            handleChange={handleChange}
          />
        </Box> */}
            </Box>

        </Box>
    );
};

export default AdmissionForm6;
